import * as userContentKeys from "../enums/userContentKeys";
import initialContentValue from "./initialContentValue";

export const DEFAULT_FILTERS_VALUE = true;

export default function getFiltersOpen(user) {
	return initialContentValue(user, userContentKeys.FILTERS_OPEN_DEFAULT, DEFAULT_FILTERS_VALUE);
}
